import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';
interface BackgroundOverlayProps {
  isOpen: boolean;
  onClick?: () => void;
}
export const BackgroundOverlay: React.FC<BackgroundOverlayProps> = ({
  isOpen,
  onClick,
}) => {
  const backgroundRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      gsap.set(backgroundRef.current, { display: 'block' });
      gsap.to(backgroundRef.current, {
        opacity: 1,
        ease: 'power4.out',
        duration: 0.5,
      });
    } else {
      gsap.to(backgroundRef.current, {
        opacity: 0,
        ease: 'power4.out',
        duration: 0.5,
        onComplete: () => {
          gsap.set(backgroundRef.current, { display: 'none' });
        },
      });
    }
  }, [isOpen]);

  return <Background ref={backgroundRef} onClick={onClick} />;
};

export const Background = styled.div`
  display: none;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.zIndex.layer};
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.backgroundOverlay};
  z-index: 9997;
`;
